import React, { useEffect, useState } from 'react';
import { Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { C, FilterSelect, Panel, StatusBadge } from '@/design-system/dna';
import { PAY_STATUS, STATUS_LABEL, TIPO_LABEL } from '../shared';

const Field = ({ label, children }) => <label className="block min-w-0"><span className="mb-1 block text-[11px] font-bold uppercase tracking-wider" style={{ color: C.muted }}>{label}</span>{children}</label>;

function DadosForm({ data, setData, eventId }) {
  const ev = data.event;
  const [f, setF] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => setF({ nome: ev.nome || '', tipo: ev.tipo, status: ev.status, data: ev.date_iso || '', horario_inicio: ev.horario_inicio || '', horario_fim: ev.horario_fim || '', local: ev.local || '', capacidade: ev.capacidade ?? '', descricao: ev.descricao || '', valor_aluno: ev.valor_aluno ?? 0 }), [ev]);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e?.target ? e.target.value : e }));
  const save = async () => {
    setSaving(true);
    try {
      const body = { ...f, capacidade: f.capacidade === '' ? null : Number(f.capacidade), valor_aluno: Number(f.valor_aluno || 0) };
      const { data: d } = await api.patch(`/eventos/${eventId}`, body); setData(d); toast.success('Evento atualizado.');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Falha ao salvar.'); } finally { setSaving(false); }
  };
  return (
    <Panel title="Dados do evento" kicker="Cadastro" testid="evento-dados" right={<Button onClick={save} disabled={saving} data-testid="evento-dados-salvar">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Salvar</Button>}>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="sm:col-span-2"><Field label="Nome"><Input value={f.nome || ''} onChange={set('nome')} data-testid="evento-nome" /></Field></div>
        <Field label="Tipo"><FilterSelect id="evento-tipo" value={f.tipo} onChange={set('tipo')} items={data.tipos.map((t) => ({ value: t, label: TIPO_LABEL[t] }))} /></Field>
        <Field label="Status"><FilterSelect id="evento-status-select" value={f.status} onChange={set('status')} items={data.status_options.map((t) => ({ value: t, label: STATUS_LABEL[t] }))} /></Field>
        <Field label="Data"><Input type="date" value={f.data || ''} onChange={set('data')} data-testid="evento-data" /></Field>
        <Field label="Início"><Input type="time" value={f.horario_inicio || ''} onChange={set('horario_inicio')} data-testid="evento-inicio" /></Field>
        <Field label="Fim"><Input type="time" value={f.horario_fim || ''} onChange={set('horario_fim')} data-testid="evento-fim" /></Field>
        <Field label="Capacidade"><Input type="number" min="0" value={f.capacidade ?? ''} onChange={set('capacidade')} data-testid="evento-capacidade" /></Field>
        <div className="sm:col-span-2"><Field label="Local"><Input value={f.local || ''} onChange={set('local')} data-testid="evento-local" /></Field></div>
        <Field label="Valor cobrado por aluno (R$)"><Input type="number" min="0" step="0.01" value={f.valor_aluno ?? 0} onChange={set('valor_aluno')} data-testid="evento-valor-aluno" /></Field>
        <div className="sm:col-span-2 lg:col-span-4"><Field label="Descrição"><Textarea rows={3} value={f.descricao || ''} onChange={set('descricao')} data-testid="evento-descricao" /></Field></div>
      </div>
    </Panel>
  );
}

export function VisaoGeral(props) {
  const d = props.data.dashboard;
  return (
    <div className="grid gap-4 xl:grid-cols-[1fr_340px]">
      <DadosForm {...props} />
      <Panel title="Situação dos participantes" kicker="Tempo real" testid="evento-situacao">
        <div className="space-y-2.5">
          {['pago', 'parcial', 'nao_pago', 'isento', 'nao_participa'].map((k) => (
            <div key={k} className="flex items-center justify-between" data-testid={`evento-situacao-${k}`}><StatusBadge tone={PAY_STATUS[k].tone}>{PAY_STATUS[k].label}</StatusBadge><b className="tabular-nums">{d.status_counts[k]}</b></div>
          ))}
          <div className="border-t pt-3 text-[12.5px]" style={{ borderColor: C.line, color: C.muted }}>Autorizações: <b style={{ color: C.green }}>{d.autorizacoes.autorizado}</b> confirmadas · <b style={{ color: C.amber }}>{d.autorizacoes.pendente}</b> aguardando · <b style={{ color: C.magenta }}>{d.autorizacoes.negado}</b> não participarão</div>
        </div>
      </Panel>
    </div>
  );
}
